import styled from 'styled-components';
import { MBox } from '../atoms/MBox';

export const StyledEmbeddedWidgetCon = styled(MBox)`
  position: ${props =>
    props.positionRelativeDisabled ? 'static' : 'relative'};
  & button {
    appearance: none;
  }

  &:hover .mr-products-container-carousel__arrows {
    opacity: 1;
  }

  & .mr-embedded-widget__offer-header {
    display: block !important;
  }
`;

export const StyledProductItemCon = styled(MBox)`
  display: flex;
  gap: 12px;

  .mr-product-item__body-wrapper {
    display: flex;
    gap: 12px;
  }

  .mr-product-item__body {
    display: flex;
    flex-grow: 1;
    flex-direction: column;
    justify-content: space-between;
  }
`;
